var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input"},[_c('inputOptional',{attrs:{"value":_vm.value,"label":_vm.$t('survey.question', { count: '' }),"callback":_vm.setValue}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }